/* eslint-disable react/jsx-no-bind */

import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import React, { Suspense } from 'react';
import { checkLoggedIn, logout, onLoggedIn, reloadDivisions } from '../utils/ProfileHelpers'; // Remove this when fully converted
import * as Sentry from '@sentry/react';

import CookieConsent from '../shared/message/CookieConsent';
import DivisionModal from '../shared/team/DivisionModal';
import Loading from '../shared/loader/Loading';
import Navigation from '../containers/Navigation';
import NotFound from '../pages/NotFoundPage/NotFound';
import PaidPlanModal from '../shared/message/PaidPlanModal';
import TopBar from './../shared/nav/TopBar';
import WizardLoading from '../shared/editor/generic/WizardLoading';
import ProfileRoutes from './ProfileRoutes';
import PublicRoutes from './PublicRoutes';
import ErrorBoundary from '../shared/ErrorBoundary'
import 'react-quill/dist/quill.snow.css';
import { Quill } from 'react-quill';

window.Quill = Quill;
class App extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.setNavActions = this.setNavActions.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.changeTeamName = this.changeTeamName.bind(this);
    this.updateNavActions = this.updateNavActions.bind(this);
    this.setAnnouncementsAsRead = this.setAnnouncementsAsRead.bind(this);
    this.openNewDivisionModal = this.openNewDivisionModal.bind(this);
    this.closeNewDivisionModal = this.closeNewDivisionModal.bind(this);
    this.showAnnouncements = this.showAnnouncements.bind(this);

    if (typeof NodeList.prototype.forEach !== 'function') {
      NodeList.prototype.forEach = Array.prototype.forEach;
    }

    this.state = {
      navActions: {},
      navOpen: false,
      announcementsRead: false,
      isCookieConsentVisible: !localStorage.getItem('gdpr-consent'),
      showNewDivisionModal: false
    };

    // TODO: Remove references to refs
    this.topBarElement = React.createRef();
    this.navigationElement = React.createRef();
    checkLoggedIn().then((response) => {
      if (response.loggedIn) {
        onLoggedIn();
      } else {
        this.props.set({ loading: false });
      }
    });
  }

  setNavActions(newNavActions) {
    let navActions = this.state.navActions;
    navActions[location.pathname] = newNavActions;
    this.setState({ navActions });
  }

  updateNavActions(newNavAction) {
    let navActions = this.state.navActions;
    navActions[location.pathname].unshift(newNavAction);
    this.setState({ navActions });
  }

  toggleMenu() {
    if (this.navigationElement) this.navigationElement.toggleMenu();
    else {
      setTimeout(
        function (self) {
          self.navigationElement.toggleMenu();
        },
        500,
        this
      );
    }
  }

  closeMenu() {
    this.setState({ navOpen: false });
  }

  changeTeamName(team) {
    // this.topBarElement.current.setTeamName(team);
  }

  setAnnouncementsAsRead() {
    this.setState({ announcementsRead: true });
  }

  openNewDivisionModal() {
    this.setState({ showNewDivisionModal: true });
  }

  closeNewDivisionModal() {
    this.setState({ showNewDivisionModal: false });
  }

  showAnnouncements() {
    this.topBarElement.current.showNotifications();
  }

  render() {
    const { team, paths } = this.props;
    const parentSelector = () => document.querySelector('.page-container');

    return (
      <Router>
        <div>
          <PaidPlanModal paths={paths} isOpen={this.props.isPaidPlanModalOpen} close={this.props.closePaidPlan} />

          <DivisionModal
            isOpen={this.state.showNewDivisionModal}
            parentSelector={parentSelector}
            close={this.closeNewDivisionModal}
            reloadDivisions={reloadDivisions}
            profile={this.props.profile}
            team={team}
          />
          <TopBar
            wrappedComponentRef={(ref) => (this.topBarElement = ref)}
            navActions={this.state.navActions}
            logout={logout}
            toggleMenu={this.toggleMenu}
            closeMenu={this.closeMenu}
            navOpen={this.state.navOpen}
            announcementsRead={this.state.announcementsRead}
            setAnnouncementsAsRead={this.setAnnouncementsAsRead}
            showDivisionModal={this.openNewDivisionModal}
          />

          <div
            className={
              'page-container container-fluid ' +
              (this.state.navOpen ? 'active ' : '') +
              (!team ? ' not-logged-in' : '')
            }
          >
            <div className="row">
              <Sentry.ErrorBoundary
                showDialog={true}
                fallback={ErrorBoundary}
                dialogOptions={({
                  subtitle: 'We have already been notified!',
                  subtitle2: 'Help us out by telling us what happened.'
                })}>
                <Suspense fallback={<Loading text="Loading team..." />}>
                  <Switch>
                    {PublicRoutes({
                      ...this.props,
                      changeTeamName: this.changeTeamName,
                      navActions: this.state.navActions,
                      setNavActions: this.setNavActions,
                      updateNavActions: this.updateNavActions,
                      toggleMenu: this.toggleMenu
                    })}

                    <ProfileRoutes
                      {...this.props}
                      openNewDivisionModal={this.openNewDivisionModal}
                      setNavActions={this.setNavActions}
                      toggleMenu={this.toggleMenu}
                    />

                    <Route component={NotFound} />
                  </Switch>
                </Suspense>
              </Sentry.ErrorBoundary>
            </div>
          </div>

          {team && (
            <Navigation
              setTeam={this.setTeam}
              setDivision={this.setDivision}
              showAnnouncements={this.showAnnouncements}
              wrappedComponentRef={(ref) => (this.navigationElement = ref)}
            />
          )}

          <WizardLoading wizardLoadingText={this.props.wizardLoadingText} />

          <CookieConsent />
        </div>
      </Router>
    );
  }
}

export default App